import { FaCheck } from "react-icons/fa";
import Button from "../components/Shared/Button/Button";

const ConfirmEmail = () => {
  return (
    <div className="grid min-h-screen place-items-center bg-lightGray">
      <div className="flex w-[716px] flex-col items-center justify-center rounded-[20px] bg-white">
        <picture className="mt-14 mb-8 grid h-28 w-28 place-items-center rounded-full bg-primary">
          <FaCheck className="h-16 w-16 text-white" />
        </picture>
        <p className="mb-14 mt-6 px-32 text-center font-pop text-2xl font-medium text-black text-opacity-50">
          We have sent you a verification email to paul@gmail.com.Please confirm
          your email address and sign in.
        </p>
        <div className="w-full px-32">
          <Button
            text="Done"
            variant="primary"
            className="mb-14 !w-full rounded-lg !py-3"
          />
        </div>
      </div>
    </div>
  );
};

export default ConfirmEmail;
